import { Divider, Link, Skeleton } from "@ds/react";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import { valuePerTitle } from "constants/sorteios";
import { useAppContext } from "contexts/AppContext";
import masks from "utils/form/masks";
import { getCurrency } from "utils/currency";
import { ReactComponent as Edit } from "assets/icons/pincel-edit-blue.svg";
import * as S from "./Pagamento.style";
import { useNavigate } from "react-router-dom";
import GoBackLink from "components/ActionFooter/GoBackLink";
import { useEffect, useState } from "react";
import useProposta from "hooks/useProposta";
import useCotacao from "hooks/useCotacao";
import { concordanceByLength } from "utils/string";
import { andCompare, ifCallback } from "utils/sonar";

const Pagamento = () => {
  const {
    titleAmount,
    personalData,
    proposta,
    setGlobalError,
    setPagamento,
    setProposta,
  } = useAppContext();

  const { salvarCotacao } = useCotacao();
  const { salvarProposta } = useProposta();

  const [frameError, setFrameError] = useState(false);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const messageListener = (event) => {
      const message = event?.data;

      ifCallback(
        andCompare(
          event.origin === window.location.origin,
          message?.type === "retorno-pagamento"
        ),
        () => {
          const { sucesso, descricaoRetorno } = message;
          ifCallback(
            !sucesso,
            () => {
              setGlobalError({
                description: descricaoRetorno,
                onClose: async () => {
                  setLoading(true);
                  const cotacaoResult = await salvarCotacao(personalData);
                  if (cotacaoResult?.type === "error") {
                    setLoading(false);
                    return;
                  }
                  const codigoCotacao =
                    cotacaoResult?.data?.[0]?.identificacao?.codigo;

                  const propostaResult = await salvarProposta(codigoCotacao);
                  if (!propostaResult?.data?.identificacao?.codigoNegocio) {
                    setLoading(false);
                    return;
                  }
                  setProposta(propostaResult?.data);
                  setFrameError(false);
                },
              });
              setFrameError(true);
            },
            () => {
              setPagamento(sucesso);
              navigate("/unico/sucesso");
            }
          );
        },
        () => null
      );
    };

    window.addEventListener("message", messageListener);
    return () => window.removeEventListener("message", messageListener);
  }, [
    navigate,
    personalData,
    salvarCotacao,
    salvarProposta,
    setGlobalError,
    setPagamento,
    setProposta,
  ]);

  return (
    <section>
      <Section>
        <ResponsiveCard maxContent title="Estamos quase lá ;)">
          <S.StyleTitle as="h3">
            Confira se os dados da compra estão corretos
          </S.StyleTitle>

          <S.ContainerDados>
            <S.ContentDados>
              <S.StyleTextDadosTitulo as="p">
                {titleAmount}{" "}
                {concordanceByLength(titleAmount, "título", "títulos")} - Cap
                Vencedor
              </S.StyleTextDadosTitulo>
              <S.StyleTextDadosTitulo as="p">
                Pagamento único com vigência de 12 meses
              </S.StyleTextDadosTitulo>

              <S.StyleTextDadosPessoais as="p">
                Valor total a pagar: R${" "}
                {getCurrency(titleAmount * valuePerTitle)}
              </S.StyleTextDadosPessoais>
            </S.ContentDados>
            <Link role="button" onClick={() => navigate("/unico")}>
              <Edit />
            </Link>
          </S.ContainerDados>
          <Divider />

          <S.ContainerDados>
            <S.ContentDados>
              <S.StyleTextDadosPessoaisSmall as="p">
                Seus dados
              </S.StyleTextDadosPessoaisSmall>
              <S.StyleTextDadosPessoais as="p">
                {personalData.dadosPessoais.nome}
              </S.StyleTextDadosPessoais>
              <S.StyleTextDadosPessoais as="p">
                {masks.cpf.mask(personalData.dadosPessoais.cpf)}
              </S.StyleTextDadosPessoais>

              <S.StyleTextDadosPessoais as="p">
                {personalData.dadosPessoais.dataNascimento}
              </S.StyleTextDadosPessoais>
            </S.ContentDados>
            <Link
              role="button"
              onClick={() => navigate("/unico/dados-pessoais")}
            >
              <Edit />
            </Link>
          </S.ContainerDados>
          <Divider />

          {loading && <Skeleton lines={4} />}

          {!frameError && (
            <S.Frame
              title="pagamento"
              scrolling="no"
              src={proposta?.cobranca?.confGateway?.urlGateWay}
              height={loading ? 0 : "1300px"}
              frameBorder="0"
              onLoad={() => {
                setLoading(false);
              }}
            />
          )}

          <GoBackLink to="/unico/dados-pessoais" />
        </ResponsiveCard>
      </Section>
    </section>
  );
};

export default Pagamento;
